import { TCreateOrganizationReqDto } from "@/api/services/admin/organization/dtos/create-organization.dto";
import { FormField } from "@/components/elements/FormField";
import { SectionCard } from "@/components/elements/SectionCard";
import { Textarea } from "@/components/elements/Textarea";
import { black } from "@/theme/colors";
import { Grid } from "@mui/material";
import { FC } from "react";
import { Control } from "react-hook-form";

type Props = {
  control: Control<TCreateOrganizationReqDto>;
};

export const OrganizationCreateOtherInfo: FC<Props> = ({ control }) => {
  return (
    <SectionCard title="その他情報（内部用）" titleVariant="head20Bold" maxWidth="100%" titleColor={black[30]}>
      <Grid container spacing={3}>
        <Grid item xs={6}>
          <FormField control={control} name="adminInfo">
            <Textarea />
          </FormField>
        </Grid>
        <Grid item xs={6}>
          <FormField control={control} name="adminNotes">
            <Textarea />
          </FormField>
        </Grid>
      </Grid>
    </SectionCard>
  );
};
